export const CONNECTION_STATUS = {
    CONNECTING: "CONNECTING",
    CONNECTED: "CONNECTED",
    FAILED: "FAILED"
};
